import { jsx as _jsx } from "react/jsx-runtime";
import { fromAccountTimezone, timestampToDateInputString, toAccountTimezone } from "../../../lib/date";
import { msToSeconds } from "../../../lib/number";
/**
 * A wrapper around <input type="datetime-local"> that converts to and from the account timezone
 * when the `defaultValueAsTimestamp` prop and `valueAsOffsetTimestamp` property are used.
 */
export default function DateTimeInput(props) {
    const inputRef = (ref) => {
        if (ref) {
            Object.defineProperty(ref, "valueAsOffsetTimestamp", {
                get() {
                    return toAccountTimezone(msToSeconds(this.valueAsNumber));
                },
                configurable: true,
            });
        }
    };
    let defaultValue = props.defaultValue;
    if (typeof props.defaultValueAsTimestamp !== "undefined") {
        defaultValue = timestampToDateInputString(fromAccountTimezone(props.defaultValueAsTimestamp));
    }
    return _jsx("input", Object.assign({ type: "datetime-local" }, props, { defaultValue: defaultValue, ref: inputRef }));
}
